"use client";

import React, { useState } from "react";

export const Input = React.forwardRef(
  (
    {
      placeholder,
      onChange,
      focus = false,
      label,
      labelIsButton = false,
      animated = false,
      databound = false,
      disabled = false,
      multiline = false,
      onInputRightClick = () => {},
      onLabelClicked = () => {},
      ...props
    },
    inputRef
  ) => {
    const [isFocussed, setIsFocussed] = useState(false);
    return (
      <div className="flex items-center w-full">
        {label && (
          <div
            className="mr-2"
            labelIsButton={labelIsButton}
            onClick={() => {
              if (labelIsButton) {
                onLabelClicked();
              }
            }}
          >
            {label}
          </div>
        )}

        {multiline && (
          <textarea
            className="outline-none mt-2 mb-2 p-1 rounded-md w-full border-none bg-[#0e1219] data-animated:border data-animated:border-green-300 data-databound:border  data-databound:border-orange-300 data-disabled:bg-gray-300 data-disabled:cursor-not-allowed"
            readOnly={disabled}
            onChange={(e) => {
              onChange(e.currentTarget.value);
            }}
            data-focus={focus}
            onContextMenu={(e) => {
              e.preventDefault();
            }}
            onMouseDown={(e) => {
              if (e.button === 2) {
                e.preventDefault();
                onInputRightClick(e);
              }
            }}
            data-animated={animated == true ? "true" : null}
            data-databound={databound == true ? "true" : null}
            data-disabled={disabled == true ? "true" : null}
            onFocus={() => {
              !disabled && setIsFocussed(true);
            }}
            onBlur={() => {
              !disabled && setIsFocussed(false);
            }}
            {...props}
          />
        )}
        {!multiline && (
          <input
            className="outline-none mt-2 mb-2 p-1 rounded-md w-full border-none bg-[#0e1219]  data-animated:border data-animated:border-green-300 data-databound:border  data-databound:border-orange-300 data-disabled:bg-gray-300 data-disabled:cursor-not-allowed"
            readOnly={disabled}
            placeholder={placeholder}
            onChange={(e) => {
              onChange(e.currentTarget.value);
            }}
            data-focus={focus}
            onContextMenu={(e) => {
              e.preventDefault();
            }}
            onMouseDown={(e) => {
              if (e.button === 2) {
                e.preventDefault();
                onInputRightClick(e);
              }
            }}
            data-animated={animated == true ? "true" : null}
            data-databound={databound == true ? "true" : null}
            data-disabled={disabled == true ? "true" : null}
            onFocus={() => {
              !disabled && setIsFocussed(true);
            }}
            onBlur={() => {
              !disabled && setIsFocussed(false);
            }}
            {...props}
          />
        )}
      </div>
    );
  }
);
